import BOOKKEEPING from '../../../api/bookkeeping.js';

const state = {
  invoices: [],
  selectedRows: [],
  dictionary: {},
  invoiceTypes: [],
  exportSidebarActive: false,
};

const getters = {};

const actions = {
  index({ commit }, url) {
    return new Promise((resolve, reject) => {
      BOOKKEEPING.index(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  indexKLA({ commit }, url) {
    return new Promise((resolve, reject) => {
      BOOKKEEPING.indexKLA(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setInvoiceTypes({ commit }, invoiceTypes) {
    commit('setInvoiceTypes', invoiceTypes);
  },
  getDictionary({ commit }) {
    return new Promise((resolve, reject) => {
      BOOKKEEPING.getDictionary()
        .then((response) => {
          localStorage.setItem(
            'dictionary',
            JSON.stringify(response.data),
          );
          commit(
            'setDictionary',
            JSON.parse(localStorage.getItem('dictionary')),
          );
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getInternalEvidencesForEvidence({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      BOOKKEEPING.getInternalEvidencesForEvidence(id)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getInternalEvidencesByPeriod({ commit }, { month, year }) {
    return new Promise((resolve, reject) => {
      BOOKKEEPING.getInternalEvidencesByPeriod(month, year)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setDictionary({ commit }, payload) {
    commit('setDictionary', payload);
  },
  getEvidenceTaxes({ commit }, payload) {
    return new Promise((resolve, reject) => {
      BOOKKEEPING.getEvidenceTaxes(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  openExportSidebar({ commit }) {
    commit('exportSidebarActive', true);
  },
  closeExportSidebar({ commit }) {
    commit('exportSidebarActive', false);
  },
  getKpirColumns({ commit }) {
    return new Promise((resolve, reject) => {
      BOOKKEEPING.indexKpirColumns()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getKpirColumnsIncome() {
    return new Promise((resolve, reject) => {
      BOOKKEEPING.indexKpirColumnsIncome()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getKpirColumnsDeduction({ commit }) {
    return new Promise((resolve, reject) => {
      BOOKKEEPING.indexKpirColumnsDeduction()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getRyczaltRates({ commit }) {
    return new Promise((resolve, reject) => {
      BOOKKEEPING.indexRyczaltRates()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  setSelectedRows(state, invoices) {
    state.selectedRows = [...invoices];
  },
  setInvoiceTypes(state, invoiceTypes) {
    state.invoiceTypes = invoiceTypes;
  },
  setDictionary(state, dictionary) {
    const payments = [];
    Object.keys(dictionary.payment_method).map((key) => {
      payments.push({ id: key, label: dictionary.payment_method[key] });
    });
    state.dictionary.payment_method = payments;

    const units = [];
    Object.keys(dictionary.unit).map((key) => {
      units.push({ id: key, label: dictionary.unit[key] });
    });
    state.dictionary.units = units;

    const vats = [];
    Object.keys(dictionary.vat).map((key) => {
      vats.push({ id: key, label: dictionary.vat[key] });
    });
    state.dictionary.vats = vats;

    state.dictionary.paid_type = Object.entries(dictionary.paid_type).map(([key, value]) => {
      return { id: key, label: value };
    });
  },
  exportSidebarActive(state, value) {
    state.exportSidebarActive = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
